import type { FetchFormResponse } from '../service/types';

export const getScsApprovalTitle = (quarter: string) =>
  quarter === 'Q2' ? 'Mid Approval' : quarter === 'Q4' ? 'End of Year Approval' : 'Approval';

export const getScsModerationOutcome = (
  data: FetchFormResponse | undefined,
  quarter: string,
  year: string,
) => {
  const outcome =
    quarter === 'Q2'
      ? data?.scs_moderation_q2
      : quarter === 'Q4'
        ? data?.scs_moderation_q4
        : undefined;
  if (!year || outcome?.complete !== true || outcome.year !== year) return undefined;
  return {
    title: quarter === 'Q2' ? 'Mid-year moderation' : 'End-year moderation',
    finalMarking: outcome.finalMarking || 'Not recorded',
    finalPosition: outcome.finalPosition || 'Not recorded',
  };
};
